import React from "react";
import { jsPDF } from "jspdf";

const print = (title = "") => {
        try {
            const mainElement = document.querySelector("main");

            if (!mainElement) {
                console.error("No main element found in document");
                alert("No main element found in document");
                return;
            }

            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: "a4",
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 20;
            const contentWidth = pageWidth - margin * 2;
            const contentHeight = pageHeight - margin * 2;

            pdf.setFontSize(20);
            pdf.setFont("helvetica", "bold");
            pdf.text("Document", pageWidth / 2, margin + 10, { align: "center" });

            pdf.setFontSize(10);
            pdf.setFont("helvetica", "normal");
            const dateStr = new Date().toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
            pdf.text(`Generated on ${dateStr}`, pageWidth / 2, margin + 20, {
                align: "center",
            });

            pdf.setLineWidth(0.5);
            pdf.line(margin, margin + 25, pageWidth - margin, margin + 25);

            let yPosition = margin + 35;

            const addTextToPDF = (text, x, y, fontSize = 10, fontStyle = "normal") => {
                pdf.setFontSize(fontSize);
                pdf.setFont("helvetica", fontStyle);

                const lines = pdf.splitTextToSize(text, contentWidth);
                const lineHeight = fontSize * 0.4;

                lines.forEach((line, index) => {
                    if (y + index * lineHeight > contentHeight) {
                        pdf.addPage();
                        y = margin;
                    }
                    pdf.text(line, x, y + index * lineHeight);
                });

                return y + lines.length * lineHeight + 5;
            };

            const processElement = (element, currentY) => {
                const tagName = element.tagName.toLowerCase();
                const text = element.textContent.trim();

                if (!text) return currentY;

                switch (tagName) {
                    case "h1":
                        currentY = addTextToPDF(text, margin, currentY, 16, "bold");
                        if(title == "") title = text;
                        break;
                    case "h2":
                        currentY = addTextToPDF(text, margin, currentY, 14, "bold");
                        break;
                    case "h3":
                        currentY = addTextToPDF(text, margin, currentY, 12, "bold");
                        break;
                    case "h4":
                    case "h5":
                    case "h6":
                        currentY = addTextToPDF(text, margin, currentY, 11, "bold");
                        break;
                    case "p":
                        currentY = addTextToPDF(text, margin, currentY, 10, "normal");
                        break;
                    case "blockquote":
                        pdf.setDrawColor(0, 123, 255);
                        pdf.setLineWidth(1);
                        pdf.line(margin, currentY, margin, currentY + 20);
                        currentY = addTextToPDF(text, margin + 5, currentY, 10, "italic");
                        break;
                    case "li":
                        currentY = addTextToPDF(`• ${text}`, margin + 5, currentY, 10, "normal");
                        break;
                    case "strong":
                    case "b":
                        currentY = addTextToPDF(text, margin, currentY, 10, "bold");
                        break;
                    case "em":
                    case "i":
                        currentY = addTextToPDF(text, margin, currentY, 10, "italic");
                        break;
                    default:
                        if (text.length > 0) {
                            currentY = addTextToPDF(text, margin, currentY, 10, "normal");
                        }
                }

                return currentY + 3;
            };

            const processAllElements = (container, currentY) => {
                const elements = Array.from(container.children);

                for (const element of elements) {
                    const skipElements = ["script", "style", "form", "input", "button", "select", "textarea"];
                    if (skipElements.includes(element.tagName.toLowerCase())) {
                        continue;
                    }

                    if (currentY > contentHeight - 20) {
                        pdf.addPage();
                        currentY = margin;
                    }

                    if (element.tagName.toLowerCase() === "table") {
                        currentY = processTable(element, currentY);
                    } else if (element.children.length > 0) {
                        currentY = processAllElements(element, currentY);
                    } else {
                        currentY = processElement(element, currentY);
                    }
                }

                return currentY;
            };

            const processTable = (table, currentY) => {
                const rows = table.querySelectorAll("tr");
                if (rows.length === 0) return currentY;

                pdf.setFontSize(8);
                pdf.setFont("helvetica", "bold");

                const cellWidth = contentWidth / 4;
                const cellHeight = 8;

                rows.forEach((row) => {
                    const cells = row.querySelectorAll("td, th");

                    if (currentY + cellHeight > contentHeight) {
                        pdf.addPage();
                        currentY = margin;
                    }

                    cells.forEach((cell, cellIndex) => {
                        const x = margin + cellIndex * cellWidth;
                        const text = cell.textContent.trim();

                        pdf.rect(x, currentY, cellWidth, cellHeight);

                        pdf.setFont("helvetica", cell.tagName.toLowerCase() === "th" ? "bold" : "normal");

                        const lines = pdf.splitTextToSize(text, cellWidth - 2);
                        if (lines.length > 0) {
                            pdf.text(lines[0], x + 1, currentY + 5);
                        }
                    });

                    currentY += cellHeight;
                });

                return currentY + 5;
            };

            yPosition = processAllElements(mainElement, yPosition);

            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setFont("helvetica", "normal");
                pdf.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, {
                    align: "center",
                });
                pdf.text(`Generated on ${new Date().toLocaleString("en-US")}`, pageWidth / 2, pageHeight - 5, {
                    align: "center",
                });
            }

            title = `${title}_${new Date().toISOString().split("T")[0]}.pdf`;
            pdf.save(title);
        } catch (error) {
            console.error("Error generating PDF:", error);
            alert("Error generating PDF. Please try again.");
        }
};

export default print;
